import { APICore, API_URL, INVESTMENT_URL } from './apiCore';
//INVESTMENT_URL is on port 4018
const api = new APICore();

const createInvestment = (clientId: string, creationReason?: string) => {
    return api.create(`${INVESTMENT_URL}/investments`, { clientId, creationReason });
};

const editInvestment = (investmentId: string, body: any) => {
    const relativeUrl = `/investments/${investmentId}`;
    return api.update(`${INVESTMENT_URL}${relativeUrl}`, body);
};

const getInvestmentStatuses = () => {
    return api.get(`${INVESTMENT_URL}/investments/statuses`);
};

const getInvestmentStatusTrackers = (params: { investmentId?: string; clientId?: string }) => {
    const url = `${INVESTMENT_URL}/investments/status-trackers`;
    return api.get(url, params);
};

export { getInvestmentStatuses, createInvestment, editInvestment, getInvestmentStatusTrackers };
